import { useEffect, useState } from 'react';

interface HeroProps {
  mousePosition: { x: number; y: number };
}

export default function Hero({ mousePosition }: HeroProps) {
  const [distortion, setDistortion] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;
    const distortX = (mousePosition.x - centerX) / 50;
    const distortY = (mousePosition.y - centerY) / 50;
    setDistortion({ x: distortX, y: distortY });
  }, [mousePosition]);

  const scrollToWork = () => {
    const element = document.getElementById('work');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center px-6 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background: `radial-gradient(circle at ${50 + distortion.x}% ${50 + distortion.y}%, rgba(200,210,255,0.15) 0%, transparent 70%)`,
          transition: 'background 0.3s ease-out',
        }}
      />

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <h1
          className="text-7xl md:text-8xl lg:text-9xl font-bold text-black leading-[0.95] mb-8"
          style={{
            fontFamily: 'Inter, sans-serif',
            letterSpacing: '-0.03em',
            transform: `translate(${distortion.x * 0.5}px, ${distortion.y * 0.5}px)`,
            transition: 'transform 0.3s ease-out',
          }}
        >
          I design experiences
          <br />
          that feel effortless.
        </h1>

        <p
          className="text-xl md:text-2xl text-black/60 mb-12 max-w-3xl mx-auto leading-relaxed"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Websites, brands, and digital products crafted with clarity and purpose.
        </p>

        <button
          onClick={scrollToWork}
          className="group relative backdrop-blur-xl bg-white/50 border border-white/80 rounded-full px-10 py-4 text-base font-medium text-black hover:bg-white/70 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          <span className="relative z-10">View My Work</span>
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-white/0 via-white/20 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </button>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-black/30"></i>
      </div>
    </section>
  );
}
